import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React from 'react';
import { FormattedMessage } from 'react-intl-next';
import Button from '@atlaskit/button/custom-theme-button';
import Drawer from '@atlaskit/drawer';
import CrossIcon from '@atlaskit/icon/glyph/cross';
import * as Styled from './styled';
import Footer from '../Footer';
import { commonMessages } from '../../messages';
import MessagesIntlProvider from '../MessagesIntlProvider';
export var FocusedTaskCloseAccount = /*#__PURE__*/function (_React$Component) {
  _inherits(FocusedTaskCloseAccount, _React$Component);
  var _super = _createSuper(FocusedTaskCloseAccount);
  function FocusedTaskCloseAccount() {
    var _this;
    _classCallCheck(this, FocusedTaskCloseAccount);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "state", {
      currentScreenIdx: 0
    });
    _defineProperty(_assertThisInitialized(_this), "nextScreen", function () {
      var screens = _this.props.screens;
      var currentScreenIdx = _this.state.currentScreenIdx;
      var nextScreenIdx = currentScreenIdx < screens.length - 1 ? currentScreenIdx + 1 : screens.length - 1;
      _this.setState({
        currentScreenIdx: nextScreenIdx
      });
    });
    _defineProperty(_assertThisInitialized(_this), "previousScreen", function () {
      var currentScreenIdx = _this.state.currentScreenIdx;
      var previousScreenIdx = currentScreenIdx - 1 >= 0 ? currentScreenIdx - 1 : 0;
      _this.setState({
        currentScreenIdx: previousScreenIdx
      });
    });
    _defineProperty(_assertThisInitialized(_this), "renderCurrentScreen", function () {
      var currentScreen = _this.props.screens[_this.state.currentScreenIdx];
      return currentScreen;
    });
    return _this;
  }
  _createClass(FocusedTaskCloseAccount, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        isOpen = _this$props.isOpen,
        onClose = _this$props.onClose,
        screens = _this$props.screens,
        submitButton = _this$props.submitButton,
        learnMoreLink = _this$props.learnMoreLink;
      var currentScreenIdx = this.state.currentScreenIdx;
      return /*#__PURE__*/React.createElement(MessagesIntlProvider, null, /*#__PURE__*/React.createElement(Drawer, {
        icon: function icon(props) {
          return /*#__PURE__*/React.createElement(CrossIcon, _extends({
            label: ""
          }, props, {
            size: "medium"
          }));
        },
        isOpen: isOpen,
        onClose: onClose,
        width: "full"
      }, /*#__PURE__*/React.createElement(Styled.DrawerInner, null, this.renderCurrentScreen(), /*#__PURE__*/React.createElement(Footer, {
        numScreens: screens.length,
        currentScreenIdx: currentScreenIdx,
        onCancel: onClose,
        onNext: this.nextScreen,
        onPrevious: this.previousScreen,
        secondaryActions: learnMoreLink && /*#__PURE__*/React.createElement(Button, {
          appearance: "subtle-link",
          spacing: "none",
          href: learnMoreLink,
          target: "_blank"
        }, /*#__PURE__*/React.createElement(FormattedMessage, commonMessages.learnMore), ' '),
        submitButton: submitButton
      }))));
    }
  }]);
  return FocusedTaskCloseAccount;
}(React.Component);
export default FocusedTaskCloseAccount;